import React from 'react';
import './MobileNav.css';

/**
 * Mobile Navigation Component
 * Bottom navigation for mobile devices
 */
const MobileNav = ({ currentView, setCurrentView }) => {
  const mobileNavItems = [
    { id: 'solana-tokens', label: 'Home', icon: '🏠' },
    { id: 'trading', label: 'Trade', icon: '⚡' },
    { id: 'solana-tokens', label: 'Top Tokens', icon: '⭐' },
    { id: 'assets', label: 'Assets', icon: '💰' },
    { id: 'settings', label: 'Settings', icon: '⚙️' }
  ];

  return (
    <nav className="mobile-nav">
      <div className="mobile-nav-container">
        {mobileNavItems.map(item => (
          <button
            key={item.id}
            className={`mobile-nav-item ${currentView === item.id ? 'active' : ''}`}
            onClick={() => setCurrentView(item.id)}
          >
            <span className="mobile-nav-icon">{item.icon}</span>
            <span className="mobile-nav-label">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default MobileNav;